import React, { Component } from "react";
import { Link, useLocation } from "react-router-dom";
import { NavLink, withRouter, Redirect } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileUpload,
  faEye,
  faUserShield,
  faHistory,
  faChartPie,
  faSearch,
  faPowerOff,
  faUsers,
  faFolder,
  faBoxOpen,
  faCity,
  faHome,
  faBook,
  faUser,
  faSitemap,
  faComment,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
  Navbar,
  Nav,
  NavDropdown,
  Form,
  FormControl,
  Button,
} from "react-bootstrap";

class Navegacion extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("api_token");
    this.props.history.push("/");
  };
  nombreMenu = (e) => {
    return <div>{ }</div>;
  };
  seguridad = () => {
    let rutaActual = this.props.history.location.pathname;
    if (!rutaActual.includes("/digital")) {
      if (localStorage.permisos) {
        if (!localStorage.permisos.split(",").includes(rutaActual) && !rutaActual.includes("/f") && !rutaActual.includes("/expediente") && !rutaActual.includes("/organigramas")) {
          return <Redirect to="/denegado" />
        }
      } else {
        localStorage.permisos = []
        return <Redirect to="/logout" />
      }
    } else {
      if (!localStorage.permisos) {
        localStorage.permisos = []
        localStorage.api_token = "3311e8f1-6f2f-4e62-afbe-b711578a5654"
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.seguridad()}
        <Navbar bg="light" expand="lg" fixed="top" className="bg-degradado">
          <Navbar.Brand >
            <img src="/er/img/logo-recopilador.png" height="30" alt="" /> Sistema
            de Entrega Recepción
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              {localStorage.permisos.includes("/escritorio") && (
                <NavLink
                  to="/escritorio"
                  className="nav-link"
                  activeClassName="NavSeleccionado"
                >
                  <FontAwesomeIcon icon={faHome} size="lg" /> Escritorio
                </NavLink>
              )}

              {localStorage.permisos.includes("/usuarios") && (
                <NavLink
                  to="/usuarios"
                  className="nav-link"
                  activeClassName="NavSeleccionado"
                >
                  <FontAwesomeIcon icon={faUsers} size="lg" /> Usuarios
                </NavLink>
              )}

              {localStorage.permisos.includes("/ambitos") && (
                <NavLink
                  to="/ambitos"
                  className="nav-link"
                  activeClassName="NavSeleccionado"
                >
                  <FontAwesomeIcon icon={faSitemap} size="lg" /> Ambitos
                </NavLink>
              )}

              {localStorage.permisos.includes("/mensajes") && (
                <NavLink
                  to="/mensajes"
                  className="nav-link"
                  activeClassName="NavSeleccionado"
                >
                  <FontAwesomeIcon icon={faEnvelope} size="lg" /> Mensajes
                </NavLink>
              )}

              {/*
              <NavLink
                to="/denegado"
                className="nav-link"
                activeClassName="NavSeleccionado"
              >
                <FontAwesomeIcon icon={faHome} size="lg" /> denegado
              </NavLink>

              
              <Nav.Link href="#link">Link</Nav.Link>
              <NavDropdown title="Administrador" id="basic-nav-dropdown">
                <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">
                  Another action
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">
                  Something
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.4">
                  Separated link
                </NavDropdown.Item>
              </NavDropdown>
            */}
            </Nav>
            <Nav>
              {this.props.muestraMensajes &&
                <a href="#!" onClick={(e) => this.props.onSetSidebarSwitch()} className="nav-link mensajes-link">
                  <FontAwesomeIcon icon={faComment} size="lg" /> Mensajes ({this.props.numMensjaes})
                </a>
              }
              <NavDropdown
                title={
                  <span>
                    <FontAwesomeIcon icon={faUser} />{" "}
                    {localStorage.nombrecompleto}
                  </span>
                }
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item href="/#" onClick={this.logout}>
                  <FontAwesomeIcon icon={faPowerOff} /> Cerrar sesión
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div className="barrainv"></div>
      </React.Fragment >
    );
  }
}

export default withRouter(Navegacion);
